import { defineMessages, type MessageDescriptor } from 'react-intl';

import type { DictationRefusal } from '@/shared/api/transcriptor';

export const transcriptorMessages = defineMessages({
  cardTitle: {
    id: 'transcriptor.card.title',
    defaultMessage: 'Transcriptor',
  },
  statusCreated: {
    id: 'transcriptor.status.created',
    defaultMessage: 'Created',
  },
  statusRecording: {
    id: 'transcriptor.status.recording',
    defaultMessage: 'Recording...',
  },
  statusProcessing: {
    id: 'transcriptor.status.processing',
    defaultMessage: 'Processing...',
  },
  statusSucceeded: {
    id: 'transcriptor.status.succeeded',
    defaultMessage: 'Completed',
  },
  statusFailed: {
    id: 'transcriptor.status.failed',
    defaultMessage: 'Failed',
  },
  statusNoSpeechDetected: {
    id: 'transcriptor.status.noSpeechDetected',
    defaultMessage: 'No speech detected',
  },
  statusUploadNotCompleted: {
    id: 'transcriptor.status.uploadNotCompleted',
    defaultMessage: 'Upload not completed',
  },
  // Consultation type messages
  consultationTypeDental: {
    id: 'transcriptorRecording.consultationTypeFull.dental',
    defaultMessage: 'Dental consultation',
  },
  consultationTypePediatric: {
    id: 'transcriptorRecording.consultationTypeFull.pediatric',
    defaultMessage: 'Pediatric consultation',
  },
  consultationTypeMedical: {
    id: 'transcriptorRecording.consultationTypeFull.medical',
    defaultMessage: 'Medical consultation',
  },
  consultationTypeCoordinatorNewPatient: {
    id: 'transcriptorRecording.consultationTypeFull.coordinatorNewPatient',
    defaultMessage: 'Coordinator - New Patient consultation',
  },
  consultationTypeCoordinatorFollowUp: {
    id: 'transcriptorRecording.consultationTypeFull.coordinatorFollowUp',
    defaultMessage: 'Coordinator - Follow Up consultation',
  },
  consultationTypeSoap: {
    id: 'transcriptorRecording.consultationTypeFull.soap',
    defaultMessage: 'SOAP Note',
  },
  reconnecting: {
    id: 'transcriptor.recording.reconnecting',
    defaultMessage: 'Reconnecting... Your recording is saved and secure.',
  },
  recordingStopped: {
    id: 'transcriptor.recording.stopped',
    defaultMessage:
      'Recording stopped - last saved at {time}. Device may have disconnected.',
  },
  generateTranscript: {
    id: 'transcriptor.recording.generateTranscript',
    defaultMessage: 'Generate Transcript',
  },
  staleRecordingMessage: {
    id: 'transcriptor.staleRecording.message',
    defaultMessage:
      'It appears the recording was interrupted. You can stop it and send for processing.',
  },
  staleRecordingStopButton: {
    id: 'transcriptor.staleRecording.stopButton',
    defaultMessage: 'Stop and process',
  },
  transcriptionDisabled: {
    id: 'transcriptor.error.transcriptionDisabled',
    defaultMessage:
      'Transcription is unavailable: your organization has no active subscription for it',
  },
  dictationLimitReached: {
    id: 'transcriptor.error.dictationLimitReached',
    defaultMessage:
      'The dictation reached its 5-minute limit and was stopped. The note keeps what was dictated.',
  },
  dictationUnavailable: {
    id: 'transcriptor.error.dictationUnavailable',
    defaultMessage:
      'Dictation is not available for your organization. Choose “Visit recording” to record.',
  },
  dictationClosed: {
    id: 'transcriptor.error.dictationClosed',
    defaultMessage:
      'This dictation is finished and cannot be continued. Start a new recording.',
  },
});

export const dictationRefusalMessages: Record<
  DictationRefusal,
  MessageDescriptor
> = {
  dictation_limit_reached: transcriptorMessages.dictationLimitReached,
  dictation_unavailable: transcriptorMessages.dictationUnavailable,
  dictation_closed: transcriptorMessages.dictationClosed,
};

export const consultationStatusMessages = {
  created: transcriptorMessages.statusCreated,
  recording: transcriptorMessages.statusRecording,
  processing: transcriptorMessages.statusProcessing,
  succeeded: transcriptorMessages.statusSucceeded,
  failed: transcriptorMessages.statusFailed,
};
